import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSession } from 'components/sessions/context/SessionContext';
import '../css/SessionForm.css';

const SessionForm = () => {
  const { addSession, convertTimeToHours, calculatePLPerHour } = useSession();
  const [date, setDate] = useState('');
  const [sessionHours, setSessionHours] = useState('');
  const [profitLoss, setProfitLoss] = useState(0);
  const [BB, setBB] = useState('');
  const [SB, setSB] = useState('');
  const [errors, setErrors] = useState({});

  const handleSubmit = async () => {
    setErrors({});
    const newErrors = {};

    if (!date) newErrors.date = 'Date is required';
    if (!sessionHours) newErrors.sessionHours = 'Session hours are required';
    if (!BB) newErrors.BB = 'BB is required';
    if (!SB) newErrors.SB = 'SB is required';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const sessionData = {
      date,
      sessionHours: convertTimeToHours(sessionHours),
      profitLoss: Number(profitLoss),
      BB: Number(BB),
      SB: Number(SB),
      timestamp: Date.now(),
    };

    try {
      await addSession(sessionData);
      setDate('');
      setSessionHours('');
      setProfitLoss(0);
      setBB('');
      setSB('');
    } catch (error) {
      console.error('Failed to add session:', error);
    }
  };

  const handleChange = (inputName, value) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[inputName];
      return updatedErrors;
    });

    if (inputName === 'sessionHours') {
      const numbers = value.replace(/[^\d]/g, '');
      if (numbers.length <= 4) {
        const formatted = numbers.length >= 3 
          ? `${numbers.slice(0, 2)}:${numbers.slice(2)}` 
          : numbers;
        setSessionHours(formatted);
      }
    } else if (inputName === 'date') setDate(value);
    else if (inputName === 'profitLoss') setProfitLoss(value);
    else if (inputName === 'BB') setBB(value);
    else if (inputName === 'SB') setSB(value);
  };

  const plPerHour = calculatePLPerHour(profitLoss, sessionHours);

  return (
    <>
      <div className="input-container">
        Day: <input className="input" type="date" value={date} onChange={(e) => handleChange('date', e.target.value)} />
        Hours: <input 
          className="hours-input"
          type="text" 
          placeholder="HH:MM"
          pattern="[0-9]{2}:[0-9]{2}"
          value={sessionHours} 
          onChange={(e) => handleChange('sessionHours', e.target.value)} 
        />
        P/L: <input className="pl-input" type="number" value={profitLoss} onChange={(e) => handleChange('profitLoss', e.target.value)} />
        {plPerHour && (
          <span className="pl-per-hour">
            ${plPerHour}/h
          </span>
        )}
        <Button variant={Object.keys(errors).length > 0 ? 'danger' : 'secondary'} className="m-1" onClick={handleSubmit}>
          Save
        </Button>
      </div>
      <div>
        SB: <input className="sb-input" type="number" value={SB} onChange={(e) => handleChange('SB', e.target.value)} />
        BB: <input className="bb-input" type="number" value={BB} onChange={(e) => handleChange('BB', e.target.value)} />
      </div>
    </>
  );
};

export default SessionForm;
